import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { DynamicSearchAdEditor } from '@bingads-webui-campaign-react/dynamic-search-ad-editor';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { useWizardService } from '@bingads-webui-react/wizard';

import { getDSAStyles } from './dsa-styles';

export const DsaEditor = ({
  ad,
  onAdChanged,
  permissions,
  scope,
}) => {
  const classes = useDefaultStyles(getDSAStyles);

  const { state } = useWizardService();
  const { domain } = state.context.wizardData;

  const onChanged = useCallback((data) => {
    onAdChanged({
      ...data,
      isValid: data.isValid,
    });
  }, [onAdChanged]);

  return (
    <div className={classNames(classes.dsa, 'dsa-ad-editor-container')}>
      <DynamicSearchAdEditor
        ad={ad}
        onAdChanged={onChanged}
        domain={domain}
        permissions={permissions}
        scope={scope}
      />
    </div>
  );
};

DsaEditor.propTypes = {
  i18n: PropTypes.shape({}).isRequired,
  ad: PropTypes.shape({
    data: PropTypes.shape({}),
  }),
  onAdChanged: PropTypes.func.isRequired,
  permissions: PropTypes.shape({}).isRequired,
  scope: PropTypes.shape({
    customerId: PropTypes.string,
    accountId: PropTypes.string,
    campaignId: PropTypes.string,
    adGroupId: PropTypes.string,
  }).isRequired,
};

DsaEditor.defaultProps = {
  ad: { data: {} },
};
